import React, { useEffect } from 'react';
import Button from './components/button/button';
import { AppGuard } from './AppGuard';

import '../sass/style.scss';
//  import { ExampleComponent } from './components/example/ExampleComponent';


export const HelloComponent = () => {

  const resultHandler = (result: any, event: any) => {
    if (event.status) {
      var html = "";
      result.forEach(function (contact: any) {
        html = html + "<div class='list-item'><a data-id='" + contact.Id + "'>" + contact.Name + "</a><p>" + contact.Phone + "</p></div>";
      });
      document.getElementById("list")!.innerHTML = html;
    } else if (event.type === "exception") {
      console.log(event.message + " : " + event.where);
    }
  }


  // const handleSubmit = () => {
  //   LCC.callApex("R6Integration.R6Controller.requestOauthToken",
  //     [],
  //     resultHandler,
  //     { escape: true });
  // }

  return (
    <div style={ { width: "fit-content", height: "fit-content"}}>
      <AppGuard></AppGuard>
    </div>
  );
}